import store from "../../../Store";
import { getContent } from "../../../content/Content";
import { Menu } from "../../../constants/Constants";
import { mapStateToProps } from "../../../content/ContentHelper";

export const RESET_HIGHLIGHTED_MENU = "resetHighlightedMenu";
export const UPDATE_NAVIGATION_MENU = "updateNavigationMenu";

export const updateNavigationMenu = payload => ({
  type: UPDATE_NAVIGATION_MENU,
  payload
});

export const resetHighlightedMenu = () => ({
  type: RESET_HIGHLIGHTED_MENU
});

export const updateMenuItems = content => {
  let reduxState = store.getState();
  let menuItems = [];

  if (reduxState.policyReducer.selectedPolicy) {
    const {
      IsLapsed,
      IsInternational,
      IsSaga
    } = reduxState.policyReducer.selectedPolicy;

    const reduxStateForContentifying = mapStateToProps(reduxState);

    menuItems = getContent(reduxStateForContentifying, content);

    if (IsInternational || IsSaga) {
      menuItems =
        menuItems &&
        menuItems.filter(item => item.menuName !== Menu.HealthStore);

      if (IsLapsed) {
        menuItems =
          menuItems &&
          menuItems.filter(item => item.menuName !== Menu.HealthSupport);
      }
    } else if (IsLapsed) {
      menuItems =
        menuItems &&
        menuItems.filter(item => item.menuName !== Menu.HealthStore);
    }
  }

  return {
    type: UPDATE_NAVIGATION_MENU,
    payload: {
      menuItems
    }
  };
};
